import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { sortKeywords } from "../../store/actions/keywordActions";
import { ArrowDropUp, ArrowDropDown } from "@material-ui/icons";
const SortKeywords = ({ sort }) => {
  const dispatcher = useDispatch();
  const domain = useSelector((state) => state.domains.currentDomain);
  const keywordsObj = useSelector((state) => state.keywords);
  const sortOrder = keywordsObj.sort[sort];

  const sorter = (sortOrder) => {
    const sortProp = { [sort]: sortOrder };
    dispatcher(
      sortKeywords(
        domain._id,
        1,
        keywordsObj.search,
        sortProp,
        keywordsObj.limit
      )
    );
  };

  const Up = () => (
    <ArrowDropUp
      onClick={() => sorter(-1)}
      style={{
        fontSize: "26px",
        cursor: "pointer",
        color: sortOrder === 1 ? "#f3452e" : "#CCC",
      }}
    />
  );
  const Down = () => (
    <ArrowDropDown
      onClick={() => sorter(1)}
      style={{
        fontSize: "26px",
        cursor: "pointer",
        color: sortOrder === -1 ? "#f3452e" : "#CCC",
      }}
    />
  );
  return <>{sortOrder === 1 ? <Up /> : <Down />}</>;
};

export default SortKeywords;
